import { isServer, QueryClient } from "@tanstack/react-query";

// The ONE app-wide QueryClient (the standard Next.js App Router singleton pattern).
//
// Why one client is enough — and why we used to (wrongly) make one per surface: every synced
// collection is keyed ["snapshot", kind, entity] (buildSyncCollection.ts), so tj and ya never
// collide on the cache. The genuinely per-kind things are the COLLECTIONS and the SSE driver —
// those mount/unmount per surface — but they share this one client. HR (read-only, no sync) uses
// it too, instead of minting its own.
//
// Server: a fresh client per request (no cross-request cache bleed). Browser: a true singleton, so
// the cache survives navigation between surfaces (tj ⇄ ya ⇄ hr) instead of being thrown away.

function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      // Collections override this with staleTime:Infinity per-query (the Full-State-Sync lock);
      // this default only governs incidental one-shot reads (e.g. HR's useHrData).
      queries: { staleTime: 60_000 },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

export function getQueryClient(): QueryClient {
  if (isServer) return makeQueryClient();
  browserQueryClient ??= makeQueryClient();
  return browserQueryClient;
}
